import { call, put, delay } from "redux-saga/effects";
import { sampleApi } from "@services/api";
import { allSubscriptionActions } from "../slices";
import { subscriptionAPI } from "@services/api/subscription/subscription";

function* allSubscriptionWorker({ payload }) {
  // yield delay(300);
  try {
    yield put(allSubscriptionActions.pending());
    const response = yield call(subscriptionAPI.getAllSubscription, payload);
    yield put(allSubscriptionActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(allSubscriptionActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { allSubscriptionWorker };
